module.exports = __webpack_public_path__ + "img/survey_main.ae4e2175.png";